import { CancelOutlined } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useState } from "react";

function PasswordTextField({ sx = [], ...props }) {
  const {
    password,
    setPassword,
    placeholder,
    name = "password",
    autoComplete = "on",
  } = props;
  const [isVisible, setIsVisible] = useState(false);
  return (
    <TextField
      autoComplete={autoComplete}
      name={name}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {password.length > 0 && (
              <IconButton
                onClick={() => {
                  setPassword("");
                }}
              >
                <CancelOutlined sx={{ fontSize: 20 }} />
              </IconButton>
            )}
            {isVisible ? (
              <IconButton onClick={() => setIsVisible(false)}>
                <VisibilityOffOutlinedIcon />
              </IconButton>
            ) : (
              <IconButton onClick={() => setIsVisible(true)}>
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
      value={password}
      onChange={(event) => {
        if (event.target.value === null) {
          setPassword("");
        } else {
          event.target.value.length <= 20 && setPassword(event.target.value);
        }
      }}
      sx={[
        {
          mt: "12px",
          "& input": {
            fontFamily: "Arial",
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      fullWidth
      type={isVisible ? "text" : "password"}
      placeholder={placeholder}
    />
  );
}

export default PasswordTextField;
